<template>
  <div class="department">
    <div class="content">
      <div class="wrap-left wow fadeInUp animated" data-wow-duration="1s"
        style="visibility: visible; animation-duration: 1s; animation-name: fadeInUp;">
        <div class="title-side"> <b>部门中心</b> </div>
        <div class="product-side">
          <ul class="level-1">
            <li :class="{ 'active': department_id == item.department_id }" v-for="(item, index) in departmentList"
              :key="index" @click="handleSelect(item.department_id)"><a href="javascript:void(0)" class="pubav">{{ item.department_name }}</a></li>
          </ul>
        </div>
      </div>
      <div class="department-info">
        <div class="department-info-item">部门名称：{{ departmentInfo.department_name }}</div>
        <div class="department-info-item">成立时间：{{ departmentInfo.createtime }}</div>
        <div class="department-info-item">部门人员规模：{{ departmentInfo.people_number }}</div>
        <div class="department-info-item">部门职能介绍：<div v-html="departmentInfo.content"></div>
        </div>
        <div class="department-info-item">部门成就：<div v-html="departmentInfo.achievement"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/http'
export default {
  name: 'Department',
  data() {
    return {
      activeIndex: 1,
      departmentList: [],
      departmentInfo: {},
      department_id: ''
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    getList() {
      http.get('/index/getDeptList').then(res => {
        console.log(res.data.data)
        if (res.code == 1) {
          this.departmentList = res.data.data
          this.department_id = res.data.data[0].department_id
          this.handleSelect(this.departmentList[0].department_id)
        }
      })
    },
    handleSelect(id) {
      this.department_id = id
      http.post('/index/getDeptDetail', { id: id }).then(res => {
        console.log('res.data.data', res)
        if (res.code == 1) {
          this.departmentInfo = res.data
        }
      })
    }
  },
}
</script>

<style scoped>
.department {}

.content {
  width: 1200px;
  height: 100vh;
  margin: 0 auto;
}

.wrap-left {
  float: left;
  width: 26%;
}

.wrap-left .title-side {
  padding: 20px 40px;
  color: #fff;
  background-color: #005bac;
}

.wrap-left .title-side b {
  font-size: 30px;
  font-weight: normal;
  display: block;
}

.wrap-left .product-side {
  background-color: #f4f8fc;
}

.wrap-left .product-side>ul>li {
  position: relative;
  border-bottom: 1px solid #fff;
}

.wrap-left .product-side>ul>li>a {
  font-size: 16px;
  line-height: 30px;
  position: relative;
  display: block;
  padding: 15px 40px;
  -webkit-transition: all .4s;
  transition: all .4s;
}

.wrap-left .product-side>ul>li.more>a:after {
  font-family: 'iconfont' !important;
  font-size: 12px;
  line-height: 60px;
  position: absolute;
  top: 0;
  right: 30px;
  display: block;
  content: '\e827';
  -webkit-transition: rotate .4s;
  transition: rotate .4s;
}
.wrap-left .product-side>ul{
  border-top: 1px solid #fff;
}
.wrap-left .product-side>ul>li.active>a,
.wrap-left .product-side>ul>li:hover>a {
  color: #fff;
  background-color: #005bac;
}

a:hover,
a:link,
a:visited {
  text-decoration: none;
  color: inherit;
}

li,
ol,
ul {
  list-style: none;
}
.department-info{
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  overflow: hidden;
  position: relative;
  min-height: 500px;
  left: 30px;
}
</style>